export default __webpack_public_path__ + "static/media/lost.5235681c.svg";